import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7e46eac1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "new"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("h1", {
  class: "en"
}, "动态新闻"), /*#__PURE__*/_createElementVNode("h2", null, "Dynamic News")])], -1));
const _hoisted_3 = {
  class: "list-content"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["list-item", {
        border: index < $data.list.length - ($data.list.length % 3 || 3)
      }]),
      key: item.unid,
      onClick: $event => $options.goDetail(item)
    }, [_createElementVNode("img", {
      src: item.titlePic
    }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(item.source), 1), _createElementVNode("div", null, _toDisplayString(item.publishTime.slice(0, 10)), 1)])], 10, _hoisted_4);
  }), 128))]), _createVNode(_component_router_link, {
    class: "home",
    to: "/home"
  })]);
}